import React, { forwardRef } from 'react';

import { useGetPermissionTags } from '@vlabs/api/artemy/client';

import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function PermissionTagsFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();

  const getPermissionTags = useGetPermissionTags();
  const permissionTagsOptions = getPermissionTags.data?.permission_tags?.map((tag) => ({
    label: tag.permission_tag,
    value: tag.permission_tag,
  })) ?? [];

  const selectedTags = filters.tags ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedTags.length === 0}
      onClickReset={() => updateFilters({ tags: undefined })}
      ref={ref}
    >
      <OptionsFilter
        isCreatable
        name="tags"
        onChange={(value) => updateFilters({ tags: value })}
        options={permissionTagsOptions}
        value={selectedTags}
        visibleCount={5}
      />
      <div className={st.Divider} />
    </PopoverWithButton>
  );
}

const PermissionTagsFilterPopoverWithRef = forwardRef(PermissionTagsFilterPopover);
export { PermissionTagsFilterPopoverWithRef as PermissionTagsFilterPopover };
